import React, { Component } from 'react';
import { Map, GoogleApiWrapper, InfoWindow, Marker } from 'google-maps-react';
import CurrentLocation from './Maplocation';

function MapContainer (props){
    
    
GoogleApiWrapper({
    apiKey: 'AIzaSyA0RbxlQeRjG7ZPfUSz1e8KV4oWzqm8Ye8'
  })

   var lc2=  CurrentLocation(props);
  //var tres =  lc2.DidMount();
   //lc2.salvarlocation
       /* return (
    <CurrentLocation
          doc={props}
         
        />
         
        )  */
      
 
}


export default MapContainer;